import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

try {
  // @ts-ignore
  if (Sentry && Sentry?.init) {
    if (environment.production) {
      // @ts-ignore
      Sentry.init({
        dsn: 'https://d8e83235290b4e2cace21864f8aca81e@o71422.ingest.sentry.io/6534268',
        release: 'nutrition_calculator@1.0.0-rc.1',
        environment: 'production',
      });

      enableProdMode();
    }

    if (environment.staging) {
      // @ts-ignore
      Sentry.init({
        dsn: 'https://d8e83235290b4e2cace21864f8aca81e@o71422.ingest.sentry.io/6534268',
        release: 'nutrition_calculator@1.0.0-rc.1',
        environment: 'staging',
      });

      enableProdMode();
    }
  } else {
    console.warn('Sentry could not be loaded');
  }
} catch (e) {
  console.warn('Sentry could not be loaded', e);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
